module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"expand_review":"查看更多","collapse_review":"显示较少"}}')
  delete Component.options._Ctor
}
